import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import { USAGE } from '@modules/ai-framework/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

// Uso & Consumo (spec-004, grupo C) — agregação de metering diário (gestor-only).
// Observabilidade, NÃO billing (RF9.2). Custo BRL chega como STRING 6 casas (Decimal→str).
class APIAiFrameworkUsage extends APITemplate {
  // GET /usage?de=&ate= -> { periodo, atualizado_ate, kpis, serie, por_agente }.
  async summary({ de, ate } = {}) {
    const params = formatQueryParams({ de: de, ate: ate })
    const r = await con.get(USAGE + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
// A classe NÃO é exportada — ninguém a consome (verificado por grep em src/),
// e export sem consumidor é código morto que o próximo leitor tenta preservar.
const apiAiFrameworkUsage = new APIAiFrameworkUsage()

export { apiAiFrameworkUsage }
